import { useInactivityTimeout } from "@/hooks/useInactivityTimeout";

export function InactivityTimeout(): null {
  useInactivityTimeout();
  return null;
}
